import { IJsonQueryLocation } from '../../../packages/api-models/common/json_query';
import { getGeoValueByType, TJsonQuery } from '../../../packages/JsonQuery';
import { ILocation, TLocation } from 'shared/types/location';
import { normalizeLocation } from './normalizeLocation';

interface IIsSublocationProps {
  currentLocation: ILocation;
  nextLocation: TLocation;
  jsonQuery: TJsonQuery;
}

/**
 * @description
 * Проверяем, что текущая локация является подлокацией для новой локации.
 * Другими словами, у нас есть небольшие города внутри крупных городов (Москва и Санкт-Петербург).
 * Мета работает с ними, если они лежат в geo -> location в jsonQuery.
 * Тем самым, проверяем, что текущая локация есть среди locations в geo и является дочерней для новой локации.
 */
export const needClearGeoLocation = ({ currentLocation, nextLocation, jsonQuery }: IIsSublocationProps) => {
  const normalizedNextLocation = normalizeLocation(nextLocation);
  const locations = getGeoValueByType<IJsonQueryLocation>('location')(jsonQuery);

  return Boolean(
    locations?.some(location => currentLocation.id === location.id) &&
    currentLocation.parentId &&
    normalizedNextLocation.some(location => location.id === currentLocation.parentId),
  );
};
